import { useTranslation } from "react-i18next";
import { allEventLevels } from "src/store/api/events/entities";

import { ColumnFiltersState } from "@tanstack/react-table";

import { FilterHeader } from "./FilterHeader";

type Props = {
    columnFilters: ColumnFiltersState;
    setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
};

export const EventLevelHeader = ({ columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["sidepanels", "common"]);
    const current = (columnFilters.find((f) => f.id === "eventLevel")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("common:table.filter.eventType")}
            sortDisabled
            options={allEventLevels.map((level) => ({ key: level, label: t(`common:table.filter.${level}`) }))}
            initialValues={Object.fromEntries(allEventLevels.map((level) => [level, current.includes(level)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "eventLevel");
                    return value.length ? [{ id: "eventLevel", value }, ...rest] : rest;
                });
            }}
        />
    );
};

export function getEventLevels(columnFilters: ColumnFiltersState): API.EventLevel[] | undefined {
    const value = columnFilters.find((f) => f.id === "eventLevel")?.value;

    if (!Array.isArray(value)) {
        return undefined;
    }

    const levels = allEventLevels.filter((level) => value.includes(level));
    return levels.length ? [...levels] : undefined;
}
